/**
 * Whether the Pype Designer route may render, given the feature flags.
 *
 * The distinction that matters is `pending` vs `denied`. `ctx.featureFlags` is
 * `undefined` until LaunchDarkly answers, which is after first render — and
 * `WithLoadingState` renders the page during loading rather than holding it
 * back. Collapsing `undefined` into "off" (the `?? false` every other flag
 * consumer uses) therefore redirects anyone who reloads or deep-links this
 * route straight to the channels list, which is exactly what presenting it as
 * the "Pype Next Theme" tab invites people to do (PSTUDIO-3768).
 *
 * `pending` is bounded: a LaunchDarkly failure now reports an empty flag map
 * rather than staying silent, so this resolves to `denied` instead of hanging.
 */
export const resolvePypeNextAccess = (
  featureFlags?: Record<string, boolean>
): 'pending' | 'allowed' | 'denied' => {
  if (!featureFlags) {
    return 'pending';
  }

  return featureFlags['pype-next'] ? 'allowed' : 'denied';
};
